


import React, { useState, useEffect } from "react";
import {
  Box, Typography, Card, Avatar, IconButton, TextField, Button,
  Grid, InputAdornment, Divider, Dialog, DialogTitle, DialogContent, 
  DialogActions, Paper, Chip
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import PersonIcon from "@mui/icons-material/Person";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import HomeIcon from "@mui/icons-material/Home";
import LockIcon from "@mui/icons-material/Lock";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate } from "react-router-dom";
import { fetchUserFromRedis } from "../AuthonticationPages/Register";
import CustomDialog from "../../CustomDialog";
import axios from 'axios';
import { apiRequest } from '../../fetchSetup';
import ResponsiveContainer from '../../ResponsiveContainer';
import LogoutIcon from "@mui/icons-material/Logout";
import { useOutletContext } from "react-router-dom";
import { ReactComponent as TabletIcon } from "../Logos/medicine-10-svgrepo-com.svg"
import  bg from "../Logos/med_icon3.png"

const ProfilePage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  const [dialog, setDialog] = useState({ 
    open: false, 
    message: "", 
    type: "info", 
    title: "Notification" 
  });
  
  const [passwordDialog, setPasswordDialog] = useState(false);
  const [passwordData, setPasswordData] = useState({ 
    new_password: "", 
    confirm_password: "" 
  });
  const [showPassword, setShowPassword] = useState({ new: false, confirm: false });

  const getuserDetailsAPI = process.env.REACT_APP_GET_USER_DETAILS_API;
  const updateProfileAPI = process.env.REACT_APP_UPDATE_USER_PROFILE_API;
  const changePasswordAPI = process.env.REACT_APP_CHANGE_PASSWORD_API;
  const { setUsername } = useOutletContext();
const amplitude = 50;   // wave height (increase = taller spike)
const baseY = 50;       // center line
const width = 500;      // total width (controls spacing)

const points = `
  0,${baseY}
  80,${baseY}
  100,${baseY - amplitude *0.2}
  120,${baseY + amplitude *0.2}
  140,${baseY - amplitude}
  160,${baseY + amplitude}
  180,${baseY}
  220,${baseY}
  240,${baseY - amplitude * 0.6}
  260,${baseY + amplitude * 0.7}
  280,${baseY}
  ${500},${baseY} 
  `
  // Helper function to format address
  const formatAddress = (address) => {
    if (!address) return "";
    if (typeof address === "string") return address;
    if (typeof address === "object") {
      const parts = [];
      if (address.street) parts.push(address.street);
      if (address.city) parts.push(address.city);
      if (address.state) parts.push(address.state);
      if (address.zipCode || address.zip_code) parts.push(address.zipCode || address.zip_code);
      if (address.country) parts.push(address.country);
      return parts.join(", ") || "";
    }
    return "";
  };

  useEffect(() => {
    const fetchAndSetUser = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");

      if (!userId || !token) {
        setUser(null);
        return;
      }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        if (userData) {
          setUser(userData);
          setFormData({
            name: userData.name || "",
            email: userData.email || "",
            phone: userData.phone || "",
            address: formatAddress(userData.address),
          });
        } else {
          setUser(null);
        }
      } catch (err) {
        console.error("Error fetching user from Redis:", err);
        setUser(null);
      }
    };

    fetchAndSetUser();
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) return;

        const res = await axios.get(getuserDetailsAPI, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.data
        if (data.user) {
          setUser(data.user);
          setFormData({
            name: data.user.name || "",
            email: data.user.email || "",
            phone: data.user.phone || "",
            address: formatAddress(data.user.address),
          });
        } else {
          setDialog({
            open: true,
            type: "error",
            title: "Error",
            message: data.error || "Failed to fetch user data"
          });
        }
      } catch (err) {
        setDialog({
          open: true,
          type: "error",
          title: "Error",
          message: "Failed to fetch user data!"
        });
      }
    };

    fetchUserData();
  }, [getuserDetailsAPI]);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSaveProfile = async () => {
    try {
      const token = sessionStorage.getItem("token");
  
      // ✅ FIXED - axios.put(url, data, config)
      const res = await axios.put(
        updateProfileAPI,
        formData,                        
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const data = res.data;
      if (data.success) {
        sessionStorage.setItem("user", JSON.stringify(data.user));
        setUser(data.user);
        setUsername(data.user.name);
        setEditMode(false);
        setDialog({
          open: true,
          type: "success",
          title: "Success",
          message: "Profile updated successfully!",
        });
      } else {
        setDialog({
          open: true,
          type: "error",
          title: "Error",
          message: data.error || "Failed to update profile",
        });
      }
    } catch (err) {
      setDialog({
        open: true,
        type: "error",
        title: "Error",
        message: "Something went wrong!",
      });
    }
  };

  const handleChangePassword = async () => {
    if (passwordData.new_password !== passwordData.confirm_password) {
      setDialog({
        open: true,
        type: "error",
        title: "Password Mismatch",
        message: "Passwords do not match!"
      });
      return;
    }

    if (passwordData.new_password.length < 6) {
      setDialog({
        open: true,
        type: "error",
        title: "Invalid Password",
        message: "Password must be at least 6 characters long!"
      });
      return;
    }

    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.put(changePasswordAPI,  passwordData,
        {headers: { "Content-Type": "application/json" }
       
      });

      const data = await res.data;
      if (res.data) {
        setDialog({
          open: true,
          type: "success",
          title: "Success",
          message: "Password updated successfully!"
        });
        setPasswordDialog(false);
        setPasswordData({ new_password: "", confirm_password: "" });
      } else {
        setDialog({
          open: true,
          type: "error",
          title: "Error",
          message: data.error || "Failed to update password"
        });
      }
    } catch (err) {
      setDialog({
        open: true,
        type: "error",
        title: "Error",
        message: "Something went wrong!"
      });
    }
  };
  const handleLogout = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const userId = sessionStorage.getItem("userId");
      const logoutapi = process.env.REACT_APP_LOGOUT_API;
      await apiRequest(`${logoutapi}/${userId}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      });
      sessionStorage.clear();
      navigate("/Login");
    } catch (error) {
      sessionStorage.clear();
      navigate("/Login");
    }
  };

  const closePasswordDialog = () => {
    setPasswordDialog(false);
    setPasswordData({ new_password: "", confirm_password: "" });
    setShowPassword({ new: false, confirm: false });
  };

  const handleCancelEdit = () => {
    setEditMode(false);
    // Reset form data to original user data
    setFormData({
      name: user?.name || "",
      email: user?.email || "",
      phone: user?.phone || "",
      address: formatAddress(user?.address),
    });
  };

  return (
    <ResponsiveContainer withSidebar={true}>
    {/* <Box sx={{ backgroundColor: "#f8f9fa", minHeight: "100vh", pb: 4 }}> */}
    <Box sx={{ 
      width: '100%',                                              // ✅ Full width of container
      maxWidth: { xs: '100%', sm: '95%', md: '1200px' },         // ✅ Max width constraint
      px: { xs: 1, sm: 2, md: 3 } 
    }}>
      {/* Header */}
      <Paper elevation={0} sx={{ 
        backgroundColor: "transparent", 
        // p: 2.5, 
        p: { xs: 1.5, sm: 2, md: 2.5 },
        display: "flex", 
        alignItems: "center",
        borderBottom: "1px solid #e0e0e0",
        position: "sticky",
        top: 0,
        zIndex: 10
      }}>
        {/* <IconButton onClick={() => navigate(-1)}sx={{color:"#006D77",marginLeft:"400px"}}>
          <ArrowBack sx={{ fontSize: 32, }} /> 
          </IconButton>
        <Typography variant="h5" sx={{marginLeft:"50px", color: "#006D77", fontWeight: 600, flexGrow: 1 }}> */}
        <IconButton 
          onClick={() => navigate(-1)}
          // sx={{
          //   color:"#006D77",
          //   marginLeft: { xs: 0, sm: "50px", lg: "400px" }
          // }}
          sx={{
            color:"#006D77",
            marginLeft: { xs: 0, sm: "20px", lg: "20px" }, // Reduced from 400px
            // marginRight: { xs: 1, sm: 2 }
          }}
        >
          <ArrowBack sx={{ fontSize: 32 }} /> 
        </IconButton>
        <Typography 
          variant="h5" 
          // sx={{
          //   marginLeft: { xs: "16px", sm: "30px", md: "50px" },
          //   color: "#006D77", 
          //   fontWeight: 600, 
          //   flexGrow: 1 
          // }}
          sx={{
            marginLeft: { xs: 0, sm: "16px", md: "30px" }, 
            color: "#006D77", 
            fontWeight: 600, 
            flexGrow: 1,
            fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' } 
          }}
        >
          Profile Management
        </Typography>
        {editMode && (
          <Chip 
            label="Editing Mode" 
            color="primary" 
            size="small"
            // sx={{ backgroundColor: "#006D77" }}
            sx={{ 
              backgroundColor: "#006D77",
              mt: { xs: 1, sm: 0 }, // Add margin-top on mobile if wrapping
              fontSize: { xs: '0.7rem', sm: '0.875rem' }
            }}
          />
        )}
      </Paper>

      {/* <Box sx={{ maxWidth: 1000, mx: "auto", mt: 4, px: 3 }}> */}
      <Box sx={{ 
        maxWidth: { xs: '100%', sm: '95%', md: 1000 }, // Responsive max-width
        mx: "auto", 
        mt: { xs: 2, sm: 3, md: 4 }, // Responsive margin-top
        px: { xs: 1, sm: 2, md: 3 } // Responsive padding
      }}>
        {/* Profile Header Card */}
        <Card 
          elevation={3}
          sx={{ 
           backgroundImage: `
            linear-gradient(135deg, rgba(0,109,119,0.9) 0%, rgba(0, 169, 181, 0.68) 100%),
            url(${bg})
          `,
          height:"150px",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat" ,     
          color: "white",
            p: 4,
            borderRadius: 3,
            mb: 4,
            position: "relative",
            overflow: "hidden"
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap" }}>
            <Avatar sx={{ 
              bgcolor: "white", 
              color: "#006D77",
              width: 100, 
              height: 100, 
              fontSize: 40,
              fontWeight: 700,
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              border: "4px solid rgba(255,255,255,0.3)"
            }}>
              {formData.name?.charAt(0)?.toUpperCase() || "U"}
            </Avatar>
            <Box sx={{ flex: 1, minWidth: 200 }}>
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                {user?.name || "User Name"}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                <EmailIcon sx={{ fontSize: 18, opacity: 0.9 }} />
                <Typography variant="body1" sx={{ opacity: 0.95 }}>
                  {user?.email || "email@example.com"}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PhoneIcon sx={{ fontSize: 18, opacity: 0.9 }} />
                <Typography variant="body1" sx={{ opacity: 0.95 }}>
                  {user?.phone || "+00 0000000000"}
                </Typography>
              </Box>
            </Box>
            {!editMode && (
              <IconButton 
                onClick={() => setEditMode(true)}
                sx={{ 
                  backgroundColor: "white",
                  color: "#006D77",
                  width: 50,
                  height: 50,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  "&:hover": { 
                    backgroundColor: "#f5f5f5",
                    transform: "scale(1.05)",
                    transition: "all 0.2s"
                  }
                }}
              >
                <EditIcon />
              </IconButton>
            )}
          </Box>
        </Card>

        {/* Personal Information Card */}
        <Card 
          elevation={2}
          sx={{ 
            borderRadius: 3, 
            overflow: "hidden",
            border: editMode ? "2px solid #006D77" : "1px solid #e0e0e0"
          }}
        >
          {/* Card Header */}
          <Box sx={{ 
            background: editMode ? "linear-gradient(90deg, #006D77 0%, #00a8b5 100%)" : "#fafafa",
            p: 3,
            borderBottom: "1px solid #e0e0e0"
          }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <PersonIcon sx={{ color: editMode ? "white" : "#006D77", mr: 1.5, fontSize: 28 }} />
                <Typography 
                  variant="h6" 
                  sx={{ 
                    color: editMode ? "white" : "#006D77", 
                    fontWeight: 600 
                  }}
                >
                  Personal Information
                </Typography>
              </Box>
              {editMode && (
                <Box sx={{ display: "flex", gap: 1.5 }}>
                  <Button 
                    variant="outlined" 
                    startIcon={<CancelIcon />}
                    onClick={handleCancelEdit}
                    sx={{ 
                      textTransform: "none",
                      borderColor: "white",
                      color: "white",
                      fontWeight: 600,
                      "&:hover": { 
                        borderColor: "white",
                        backgroundColor: "rgba(255,255,255,0.1)"
                      }
                    }}
                  >
                    Cancel
                  </Button>
                  <Button 
                    variant="contained" 
                    startIcon={<SaveIcon />}
                    onClick={handleSaveProfile}
                    sx={{ 
                      textTransform: "none",
                      backgroundColor: "white",
                      color: "#006D77",
                      fontWeight: 600,
                      "&:hover": { 
                        backgroundColor: "#f5f5f5"
                      }
                    }}
                  >
                    Save Changes
                  </Button>
                </Box>
              )}
            </Box>
          </Box>

          {/* Card Content */}
          <Box sx={{ p: 4 }}>
            {editMode ? (
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography 
                      variant="subtitle2" 
                      sx={{ 
                        color: "#006D77", 
                        fontWeight: 600,
                        mb: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                      }}
                    >
                      <PersonIcon sx={{ fontSize: 18 }} />
                      Full Name
                    </Typography>
                    <TextField
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      fullWidth
                      placeholder="Enter your full name"
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white",
                          "&:hover fieldset": {
                            borderColor: "#006D77",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#006D77",
                            borderWidth: 2
                          }
                        }
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography 
                      variant="subtitle2" 
                      sx={{ 
                        color: "#006D77", 
                        fontWeight: 600,
                        mb: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                      }}
                    >
                      <EmailIcon sx={{ fontSize: 18 }} />
                      Email Address
                      <Chip label="Read Only" size="small" sx={{ ml: 1, height: 20 }} />
                    </Typography>
                    <TextField
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      fullWidth
                      disabled
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f5f5f5",
                        }
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography 
                      variant="subtitle2" 
                      sx={{ 
                        color: "#006D77", 
                        fontWeight: 600,
                        mb: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                      }}
                    >
                      <PhoneIcon sx={{ fontSize: 18 }} />
                      Phone Number
                      <Chip label="Read Only" size="small" sx={{ ml: 1, height: 20 }} />
                    </Typography>
                    <TextField
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      fullWidth
                      disabled
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f5f5f5",
                        }
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Paper 
                    elevation={0}
                    sx={{ 
                      backgroundColor: "#f8f9fa", 
                      p: 2.5, 
                      borderRadius: 2,
                      border: "1px solid #e9ecef",
                      transition: "all 0.2s",
                      "&:hover": {
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        transform: "translateY(-2px)"
                      }
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                      <PersonIcon sx={{ color: "#006D77", fontSize: 20 }} />
                      <Typography 
                        variant="caption" 
                        sx={{ 
                          color: "#6c757d", 
                          fontWeight: 600,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                          fontSize: "0.75rem"
                        }}
                      >
                        Full Name
                      </Typography>
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: "#212529" }}>
                      {user?.name || "-"}
                    </Typography>
                  </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Paper 
                    elevation={0}
                    sx={{ 
                      backgroundColor: "#f8f9fa", 
                      p: 2.5, 
                      borderRadius: 2,
                      border: "1px solid #e9ecef",
                      transition: "all 0.2s",
                      "&:hover": {
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        transform: "translateY(-2px)"
                      }
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                      <EmailIcon sx={{ color: "#006D77", fontSize: 20 }} />
                      <Typography 
                        variant="caption" 
                        sx={{ 
                          color: "#6c757d", 
                          fontWeight: 600,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                          fontSize: "0.75rem"
                        }}
                      >
                        Email Address
                      </Typography>
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: "#212529", wordBreak: "break-word" }}>
                      {user?.email || "-"}
                    </Typography>
                  </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Paper 
                    elevation={0}
                    sx={{ 
                      backgroundColor: "#f8f9fa", 
                      p: 2.5, 
                      borderRadius: 2,
                      border: "1px solid #e9ecef",
                      transition: "all 0.2s",
                      "&:hover": {
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        transform: "translateY(-2px)"
                      }
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                      <PhoneIcon sx={{ color: "#006D77", fontSize: 20 }} />
                      <Typography 
                        variant="caption" 
                        sx={{ 
                          color: "#6c757d", 
                          fontWeight: 600,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                          fontSize: "0.75rem"
                        }}
                      >
                        Phone Number
                      </Typography>
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: "#212529" }}>
                      {user?.phone || "-"}
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            )}
          </Box>

          {/* Security Section */}
          {!editMode && (
            <>
              <Divider />
              <Box sx={{ p: 3, backgroundColor: "#fafafa" }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <LockIcon sx={{ color: "#006D77", fontSize: 24 }} />
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#212529" }}>
                        Security Settings
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#6c757d" }}>
                        Update your password to keep your account secure
                      </Typography>
                    </Box>
                  </Box>
                  <Button
                    variant="outlined"
                    startIcon={<LockIcon />}
                    onClick={() => setPasswordDialog(true)}
                    sx={{
                      textTransform: "none",
                      borderColor: "#006D77",
                      color: "#006D77",
                      fontWeight: 600,
                      px: 3,
                      "&:hover": { 
                        borderColor: "#006D77",
                        backgroundColor: "rgba(0, 109, 119, 0.08)" 
                      }
                    }}
                  >
                    Change Password
                  </Button>
                  <Button
    variant="outlined"
    startIcon={<LogoutIcon />}
    onClick={handleLogout}
    sx={{
      textTransform: "none",
      borderColor: "#d32f2f",
      color: "#d32f2f",
      fontWeight: 600,
      px: 3,
      "&:hover": { 
        borderColor: "#d32f2f",
        backgroundColor: "rgba(211, 47, 47, 0.08)" 
      }
    }}
  >
    Logout
  </Button>
                </Box>
              </Box>
            </>
          )}
        </Card>
      </Box>

      {/* Password Change Dialog */}
      <Dialog 
        open={passwordDialog} 
        onClose={closePasswordDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{ 
          sx: { 
            borderRadius: 3,
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)"
          } 
        }}
      >
        <DialogTitle sx={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center",
          background: "linear-gradient(135deg, #006D77 0%, #00a8b5 100%)",
          color: "white",
          p: 3
        }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <LockIcon />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Change Password
            </Typography>
          </Box>
          <IconButton onClick={closePasswordDialog} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        
        <DialogContent sx={{ p: 4 }}>
          <Typography variant="body2" sx={{ color: "#6c757d", mb: 3 }}>
            Your password must be at least 8 characters long
          </Typography>
          
          <TextField
            label="New Password"
            name="new_password"
            type={showPassword.new ? "text" : "password"}
            fullWidth
            margin="normal"
            value={passwordData.new_password}
            onChange={(e) => setPasswordData({ ...passwordData, new_password: e.target.value })}
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root": {
                "&:hover fieldset": {
                  borderColor: "#006D77",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#006D77",
                }
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton 
                    onClick={() => setShowPassword({ ...showPassword, new: !showPassword.new })}
                    edge="end"
                  >
                    {showPassword.new ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          
          <TextField
            label="Confirm Password"
            name="confirm_password"
            type={showPassword.confirm ? "text" : "password"}
            fullWidth
            margin="normal"
            value={passwordData.confirm_password}
            onChange={(e) => setPasswordData({ ...passwordData, confirm_password: e.target.value })}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&:hover fieldset": {
                  borderColor: "#006D77",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#006D77",
                }
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton 
                    onClick={() => setShowPassword({ ...showPassword, confirm: !showPassword.confirm })}
                    edge="end"
                  >
                    {showPassword.confirm ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        
        <DialogActions sx={{ p: 3, gap: 1.5, backgroundColor: "#fafafa" }}>
          <Button 
            onClick={closePasswordDialog}
            variant="outlined"
            sx={{ 
              textTransform: "none",
              borderColor: "#006D77",
              color: "#006D77",
              fontWeight: 600,
              px: 3
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleChangePassword}
            variant="contained"
            disabled={!passwordData.new_password || !passwordData.confirm_password}
            sx={{ 
              textTransform: "none",
              backgroundColor: "#006D77",
              fontWeight: 600,
              px: 3,
              "&:hover": { backgroundColor: "#005f64" },
              "&:disabled": { backgroundColor: "#cccccc" }
            }}
          >
            Update Password
          </Button>
        </DialogActions>
      </Dialog>

      {/* Notification Dialog */}
      <CustomDialog
        open={dialog.open}
        onClose={() => setDialog({ ...dialog, open: false })}
        type={dialog.type}
        title={dialog.title}
        message={dialog.message}
        buttonText="OK"
      />
    </Box>
    </ResponsiveContainer>
  );
};

export default ProfilePage;